import { api } from "../component/constent";

// Consignee List
export const procConsigneeList = () =>
  api.post("/reports/consigneeList", {});

// Rate List
export const procRateList = () =>
  api.post("/reports/rateList", {});

// Allocation List
export const procAllocationList = () =>
  api.post("/reports/allocationList", {});

// Report Process
export const procReportProcess = (month, year) =>
  api.post("/reports/reportprocess", { month, year, });

// IOH / POH Report
export const executeReportProcedure = (month, year, reportType) =>
  api.get("/reports/iohpoh", { params: { month, year, reportType, }, });


// C6 - Store Schedule
export const C6ReportProcedure = (month, year) =>
  api.get("/reports/storeshedule", { params: { month, year, }, });

// C7 - Labour Schedule
export const C7ReportProcedure = (month, year) =>
  api.get("/reports/labourshedule", { params: { month, year, }, });

// C8 - Capital & C8
export const C8ReportProcedure = (month, year) =>
  api.get("/reports/capitalandc8", { params: { month, year, }, });

//WGR and WGR On Cost
  export const getWGR = (month, year,type) =>
  api.get("/reports/wgr", { params: { month, year, type, }, });

//Labour Sub Laedger
  export const getLSL = (month, year) =>
  api.get("/reports/lsl", {params: { month, year, }, });

  // DIVISIONAL ALLOCATION SUMMARY 
  export const getDSA = (month, year) =>
  api.get("/reports/dsa", { params: { month,  year, }, });

  // IOH 
  export const getIOH = (month, year) =>
  api.get("/reports/ioh", { params: { month,  year, }, });

  // POH 
  export const getPOH = (month, year) =>
  api.get("/reports/poh", { params: { month,  year, }, });

  // Cost Ananlysis 
  export const costAnalysisProcedure = (month, year) =>
  api.get("/reports/oncost", { params: { month,  year, }, });

  // Demand Summery
  export const dwsProcedure = (month, year) =>
  api.get("/reports/demandsummery", { params: { month,  year, }, });

  //Demand Details
  export const dwsDetailsProcedure = (month, year) =>
  api.get("/reports/demanddetails", { params: { month,  year, }, });

  //Repair Cost
  export const rcProcedure = (month, year) =>
  api.get("/reports/repaircost", { params: { month,  year, }, });

  //Under Over Cost
  export const uoProcedure = (month, year) =>
  api.get("/reports/underovercharge", { params: { month,  year, }, });

  //JV Data
  export const getJVData = (reportType, month, year) =>
  api.get(`/reports/jv/${reportType}`, { params: { reportType, month, year, }, });

  //JV List
   export const getJVList = (type,month, year) =>
  api.get("/reports/jvlist", { params: {  type,month, year, }, });


//CAPITAL JV Data
  export const getCapJVData = (month, year) =>
  api.get("/reports/capjv", { params: {  month, year, }, });



//CONTROL1  Data
  export const getControl1 = (month, year) =>
  api.get("/reports/control1", { params: {  month, year, }, });

//CONTROL2  Data
  export const getControl2 = (month, year) =>
  api.get("/reports/control2", { params: {  month, year, }, });


  //CONTROL2  Data
  export const getActual = (month, year) =>
  api.get("/reports/actual", { params: {  month, year, }, });


  // Workshop Account
export const workshopAccountProcedure = (month, year) =>
  api.post("/procedure/execute", {reportId: 28, params: [month, year],});


// Grand Summary Report
export const GrandSummeryReportProcedure = (month, year) =>
  api.post("/procedure/execute", {reportId: 9, params: [month, year],});

//Appraisal  Data
  export const getAppraisal = (qtr, year) =>
  api.get("/reports/appraisal", { params: {  qtr, year, }, });

  export const qtrCost = (month, year) =>
  api.post("/procedure/execute", {reportId: 33, params: [month, year],});

  export const qtrExpenditure = (month, year) =>
  api.post("/procedure/execute", {reportId: 34, params: [month, year],});
